<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('backupsettings' , 1) }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'edit-backup-settings?cinema_id='+cine_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="backup-settings"
        >{{ $tc('backupsettings' , 1) }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('cinema', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ cinema_config.cinem_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('backuplocationbrowse') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">Downloads</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $tc('backup', 2) }} {{ $tc('schedule', 2) }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                v-if="cinema_config.bt_type == 'Weekly'"
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $t('weekly') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                v-if="cinema_config.bt_type == 'Fortnight'"
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $t('fortnight') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                v-if="cinema_config.bt_type == 'Daily'"
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $t('daily') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div
                v-if="cinema_config.bt_type == 'Monthly'"
                class="col-md-3 col-lg-2 col-xl-2"
              >{{ $t('monthly') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10"></div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                v-if="cinema_config.bs_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-12" v-if=" GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ cinema_config.created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ cinema_config.created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ cinema_config.updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ cinema_config.updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CinemasService from "@/services/CinemasService.js";
import MasterService from "@/services/MasterService.js";
export default {
  data() {
    return {
      Cinemas: [],
      selectedCinema: [],
      cine_id: null,
      cinema_config: {}
    };
  },
  beforeMount() {
    const { cinema_id } = this.$route.query;
    if (cinema_id) {
      this.getCinemaList(cinema_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getCinemaList: function(cinema_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (x.cine_id == cinema_id) {
                this.selectedCinema = x.cine_name;
                this.cine_id = x.cine_id;
              }
            });
            this.getCinemaBackupSettings(cinema_id);
          } else {
            this.$toasted.show(data.message);
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetActiveCinemas :", error);
        });
    },
    getCinemaBackupSettings: function(cinema_id) {
      let payload = {
        cinema_id: cinema_id
      };
      CinemasService.ReadABackupSetting(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.cinema_config = data.Records[0];
            this.getViewUsersDetails(
              this.cinema_config.created_by,
              "created_by"
            );
            this.getViewUsersDetails(
              this.cinema_config.updated_by,
              "updated_by"
            );
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          this.$toasted.show(err);
        });
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinema_config[key] = data.Records[0].user_name;
            } else {
              // Error Message
              console.log("data.message :", data.message);
            }
          })
          .catch(error => {
            // Catch Error
            console.log("Catch Error on getViewUsersDetails :", error);
          });
      }
    }
  }
};
</script>
 


// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/BackupSettingComponent/viewBackupSettings.vue